import React from "react";
import Button from "@material-ui/core/Button";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import withIntl from "../../utils/withIntl";
import Typography from "@material-ui/core/Typography";
import { TextField, Tooltip } from "@material-ui/core";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

function ChangeAmountButtons(props) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ justifyContent: "flex-end", width: "50%" }}>
        <Typography align={"right"}>{props.label}</Typography>
      </div>
      <div style={{ width: "30%" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          {/*<IconButton disabled>*/}
          {/*  <RemoveCircleOutlineIcon />*/}
          {/*</IconButton>*/}
          <div style={{ width: 200 }}>
            <TextField
              variant={"standard"}
              placeholder={props.placeholder ?? ""}
              type={"number"}
              error={props.error ?? false}
              size={"small"}
              inputProps={props.inputProps ?? {}}
              fullWidth
              value={props.value}
              onChange={(e) => {
                props.setValue(e.target.value);
              }}
              InputProps={props.InputProps ?? null}
            />
          </div>
          {/*<IconButton disabled>*/}
          {/*  <AddCircleIcon />*/}
          {/*</IconButton>*/}
        </div>
      </div>
      <div style={{ width: "20%" }}>
        <Tooltip title={"remove"}>
          <IconButton color={"primary"} onClick={props.onDelete}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
}

export default withIntl(ChangeAmountButtons);
